import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
  inject, LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { provideNgIconLoader } from '@spartan-ng/ui-icon-helm';
import { withCaching } from '@ng-icons/core';
import { httpInterceptor } from '@hp-auth/_interceptors/http.interceptor';
import {provideTranslation} from "@hp-core/i18n/provide-translation";
import { DatePipe } from '@angular/common';
import { environment } from '../environments/environment';
import { PosthogService } from '@hp-core/services/posthog.service';
import { PosthogErrorHandler } from '@hp-core/error-handlers/posthog-error-handler';

function initPosthog(posthog: PosthogService) {
  return () => posthog.init(environment.posthogKey, environment.posthogApiHost);
}

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'es-AR'},
    { provide: ErrorHandler, useClass: PosthogErrorHandler },
    {
      provide: APP_INITIALIZER,
      useFactory: initPosthog,
      deps: [PosthogService],
      multi: true,
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideTranslation,
    provideHttpClient(withInterceptors([httpInterceptor])),
    provideNgIconLoader((name) => {
      const http = inject(HttpClient);
      return http.get(`assets/icons/${name}.svg`, { responseType: 'text' });
    }, withCaching()),
    DatePipe
  ],
};
